import React from "react";
import "./Stats.css";
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import LocalLibraryIcon from "@material-ui/icons/LocalLibrary";
import BookIcon from "@material-ui/icons/Book";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";

const metrics = [
    {
        label: "Volumes Indexed",
        value: "3,254",
        hint: "↑ 182 this month",
        icon: <LibraryBooksIcon />,
    },
    {
        label: "Active Members",
        value: "254",
        hint: "Staff & students",
        icon: <LocalLibraryIcon />,
    },
    {
        label: "Reservations Today",
        value: "54",
        hint: "Real-time circulation",
        icon: <BookIcon />,
    },
    {
        label: "Curated Collections",
        value: "18",
        hint: "Special releases",
        icon: <EmojiEventsIcon />,
    },
];

function Stats() {
    return (
        <section className="stats">
            <div className="stats__grid">
                {metrics.map((metric) => (
                    <article className="stats__card" key={metric.label}>
                        <div className="stats__icon">{metric.icon}</div>
                        <div className="stats__meta">
                            <span className="stats__label">{metric.label}</span>
                            <strong className="stats__value">{metric.value}</strong>
                            <span className="stats__hint">{metric.hint}</span>
                        </div>
                    </article>
                ))}
            </div>
        </section>
    );
}

export default Stats;